import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { API } from '../config';

// Seconda finestra (fumé) di Indaga: confronto campo-per-campo tra il record in archivio
// (Attuale) e i dati trovati dall'indagine (Trovato). L'utente spunta i campi da aggiornare
// e li applica via /indaga/applica. Riusa le "proposte" gia' calcolate dal backend.
const IconClose = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
);

const CONFERMA_BADGE = {
  diretto: { t: 'Identità confermata (match per numero)', c: '#22c55e' },
  piva: { t: 'Identità confermata (P.IVA combacia)', c: '#22c55e' },
  da_confermare: { t: 'Identità da confermare (match per nome)', c: '#f59e0b' },
};

const val = (v) => Array.isArray(v) ? v.join(', ') : (v == null || v === '' ? '—' : String(v));

export default function IndagaConfrontaDialog({ open, onClose, numeroId, proposte, conferma, dati, onApplied }) {
  const [sel, setSel] = useState({});
  const [busy, setBusy] = useState(false);
  const [esito, setEsito] = useState(null);

  // pre-spunta secondo il default_on calcolato dal backend, a ogni apertura
  useEffect(() => {
    if (!open) return;
    const init = {};
    (proposte || []).forEach((p) => { init[p.chiave] = !!p.default_on; });
    setSel(init); setEsito(null);
  }, [open, proposte]);

  if (!open) return null;

  const props = proposte || [];
  const scelti = props.filter((p) => sel[p.chiave]).map((p) => p.chiave);
  const cbadge = conferma && CONFERMA_BADGE[conferma];

  const applica = async () => {
    if (!scelti.length) return;
    setBusy(true); setEsito(null);
    try {
      const r = await axios.post(`${API}/indaga/applica`, { numero_id: numeroId, dati: dati || {}, campi: scelti });
      setEsito({ ok: true, aggiornati: r.data.aggiornati || [], avvisi: r.data.avvisi || [] });
      if (onApplied) onApplied(r.data);
    } catch (e) {
      setEsito({ ok: false, msg: e.response?.data?.detail || 'Errore in aggiornamento' });
    }
    setBusy(false);
  };

  return createPortal(
    <div className="bulk-overlay" style={{ zIndex: 10050 }} onClick={onClose}>
      <div className="bulk-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="bulk-content">
          <div className="bulk-head">
            <span className="bulk-title">Confronta e aggiorna</span>
            <button className="bulk-x" onClick={onClose}><IconClose /></button>
          </div>

          {cbadge && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 700, color: '#fff', background: cbadge.c, padding: '3px 10px', borderRadius: 999, marginBottom: 12 }}>{cbadge.t}</div>
          )}

          {!props.length ? (
            <div style={{ color: 'rgba(255,255,255,.65)', fontSize: 13.5, padding: '10px 0' }}>
              Nessuna differenza: il record in archivio è già allineato ai dati trovati.
            </div>
          ) : (
            <>
              <div style={{ fontSize: 12.5, color: 'rgba(255,255,255,.5)', marginBottom: 8 }}>Spunta i campi da aggiornare nel record:</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {props.map((p) => (
                  <label key={p.chiave} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,.07)', cursor: 'pointer' }}>
                    <input type="checkbox" checked={!!sel[p.chiave]} onChange={(e) => setSel((s) => ({ ...s, [p.chiave]: e.target.checked }))}
                      style={{ marginTop: 3, width: 16, height: 16, accentColor: '#f97316', flex: '0 0 auto' }} />
                    <span style={{ flex: 1, minWidth: 0 }}>
                      <span style={{ fontSize: 12, color: 'rgba(255,255,255,.55)', fontWeight: 700 }}>{p.etichetta}</span>
                      <span style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', fontSize: 13, marginTop: 2 }}>
                        <span style={{ color: 'rgba(255,255,255,.45)', textDecoration: p.attuale ? 'line-through' : 'none', wordBreak: 'break-word' }}>{val(p.attuale)}</span>
                        <span style={{ color: 'rgba(255,255,255,.35)' }}>→</span>
                        <span style={{ color: '#fdba74', fontWeight: 600, wordBreak: 'break-word' }}>{val(p.trovato)}</span>
                      </span>
                    </span>
                  </label>
                ))}
              </div>
            </>
          )}

          {esito && (
            <div style={{ marginTop: 12, fontSize: 13, color: esito.ok ? '#86efac' : '#fca5a5' }}>
              {esito.ok
                ? (esito.aggiornati.length ? `Aggiornati: ${esito.aggiornati.join(', ')}` : 'Nessun campo aggiornato')
                : esito.msg}
              {esito.ok && esito.avvisi.map((a, i) => <div key={i} style={{ color: '#fbbf24', marginTop: 3 }}>{a}</div>)}
            </div>
          )}

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
            <button onClick={onClose} style={{ padding: '10px 16px', borderRadius: 10, border: '1px solid rgba(255,255,255,.16)', background: 'transparent', color: 'rgba(255,255,255,.8)', fontWeight: 700, cursor: 'pointer' }}>Chiudi</button>
            {!!props.length && !(esito && esito.ok) && (
              <button onClick={applica} disabled={busy || !scelti.length}
                style={{ padding: '10px 18px', borderRadius: 10, border: 0, fontWeight: 800, cursor: busy || !scelti.length ? 'default' : 'pointer', opacity: busy || !scelti.length ? 0.55 : 1, color: '#fff', background: 'linear-gradient(180deg,#fb923c,#ea580c)' }}>
                {busy ? '…' : `Applica${scelti.length ? ` (${scelti.length})` : ''}`}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
